import { render, staticRenderFns } from "./InfoBoxes.vue?vue&type=template&id=467d2c78&"
import script from "./InfoBoxes.js?vue&type=script&lang=js&"
export * from "./InfoBoxes.js?vue&type=script&lang=js&"
import style0 from "./InfoBoxes.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports